module.exports = __webpack_public_path__ + "img/free.b50a7751.gif";